"use strict";

export default [
  {
    grkey: "6LfVu5cUAAAAAGze-xSKjgKs3R9AGt2w6OPRZTmU"
  }
];
